import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/operator-tenant',
    name: 'operator-tenant',
    component: () => lazyLoadView(import('@views/admin/operator/tenant/List.vue')),
    meta: {
      title: 'Admin Tenant',
    },
  },
  {
    path: '/:operator/:id(\\d+)/operator-tenant/:operator_id(\\d+)',
    name: 'operator-tenant-detil',
    component: () => lazyLoadView(import('@views/admin/operator/tenant/Detail.vue')),
    meta: {
      title: 'Detil Admin Tenant',
    },
  },

  {
    path: '/:operator/:id(\\d+)/operator-organisasi',
    name: 'operator-organisasi',
    component: () => lazyLoadView(import('@views/admin/operator/organisasi/List.vue')),
    meta: {
      title: 'Admin Organisasi',
    },
  },
  {
    path: '/:operator/:id(\\d+)/operator-organisasi/:operator_id(\\d+)',
    name: 'operator-organisasi-detil',
    component: () => lazyLoadView(import('@views/admin/operator/organisasi/Detail.vue')),
    meta: {
      title: 'Detil Admin Organisasi',
    },
  },

  {
    path: '/:operator/:id(\\d+)/operator-lokasi',
    name: 'operator-lokasi',
    component: () => lazyLoadView(import('@views/admin/operator/lokasi/List.vue')),
    meta: {
      title: 'Admin Lokasi',
    },
  },
  {
    path: '/:operator/:id(\\d+)/operator-lokasi/:operator_id(\\d+)',
    name: 'operator-lokasi-detil',
    component: () => lazyLoadView(import('@views/admin/operator/lokasi/Detail.vue')),
    meta: {
      title: 'Detil Admin Lokasi',
    },
  },

  {
    path: '/:operator/:id(\\d+)/operator-loket',
    name: 'operator-loket',
    component: () => lazyLoadView(import('@views/admin/operator/loket/List.vue')),
    meta: {
      title: 'Admin Loket',
    },
  },
  {
    path: '/:operator/:id(\\d+)/operator-loket/:operator_id(\\d+)',
    name: 'operator-loket-detil',
    component: () => lazyLoadView(import('@views/admin/operator/loket/Detail.vue')),
    meta: {
      title: 'Detil Admin Loket',
    },
  },
];
